import { sortBy } from 'lodash';
import {
  CalculsFormCalendrierDeficitFonctionnelTemporaireTotal,
  CalculsGlobal,
} from 'src/constants/calculs';
import { prejudiceBaseDefaultValues } from 'src/constants/prejudice/defaultValues';
import {
  PrejudiceFormCalendrierDeficitFonctionnelTemporaireTotal,
  PrejudiceFormCalendrierDeficitFonctionnelTemporaireTotalRow,
} from 'src/types/prejudice.type';
import { Procedure } from 'src/types/procedure.type';

export type DFTTRowExistingValues =
  Partial<PrejudiceFormCalendrierDeficitFonctionnelTemporaireTotalRow>;
export type DFTTExistingValues = Omit<
  Partial<PrejudiceFormCalendrierDeficitFonctionnelTemporaireTotal>,
  'rows'
> & {
  rows?: DFTTRowExistingValues[];
};

export const getCalendrierDeficitFonctionnelTemporaireTotalRowDefaultValues = (
  values: DFTTExistingValues,
  existingRowValues: DFTTRowExistingValues,
): PrejudiceFormCalendrierDeficitFonctionnelTemporaireTotalRow => {
  const dateDebut = existingRowValues.dateDebut || null;
  const dateFin = existingRowValues.dateFin || null;
  const totalJours =
    dateDebut && dateFin ? CalculsGlobal.getDays(dateDebut, dateFin) : 0;
  const forfaitJour = values?.forfaitJour || existingRowValues.forfaitJour || 0;
  const montantTotal =
    CalculsFormCalendrierDeficitFonctionnelTemporaireTotal.montantTotal({
      totalJours,
      forfaitJour,
    });
  const numerosPieces = existingRowValues.numerosPieces || { rows: [] };
  const motifHospitalisation = existingRowValues.motifHospitalisation || '';
  return {
    dateDebut,
    dateFin,
    totalJours,
    forfaitJour,
    montantTotal,
    numerosPieces,
    motifHospitalisation,
  };
};
export const calendrierDeficitFonctionnelTemporaireTotalDefaultValues = ({
  values,
  procedure,
  isExtractedValues,
}: {
  values: DFTTExistingValues | undefined;
  procedure: Procedure;
  isExtractedValues: boolean;
}): PrejudiceFormCalendrierDeficitFonctionnelTemporaireTotal => {
  const baseValues = prejudiceBaseDefaultValues({
    values,
  });
  const forfaitJour =
    (values && !isExtractedValues
      ? values?.forfaitJour
      : procedure.baremes?.forfaitJourDFTT) ?? 0;
  const valuesWithForfaitJour: DFTTExistingValues = {
    ...baseValues,
    forfaitJour,
  };
  const rows =
    sortBy(values?.rows || [], (row) => row.dateDebut)?.map((row) => ({
      ...getCalendrierDeficitFonctionnelTemporaireTotalRowDefaultValues(
        valuesWithForfaitJour,
        row,
      ),
      ...row,
    })) || [];
  return {
    ...baseValues,
    forfaitJour,
    rows,
  };
};
